import { useTranslation } from 'react-i18next'
import { AppShell } from '@/shared/ui/AppShell'
import { useAuth } from '@/features/auth/state/useAuth'
import { useSettingsTab } from '../state/useSettingsTab'
import { ReadOnlyBanner } from './ReadOnlyBanner'
import { SettingsTabs } from './SettingsTabs'
import { TabPlaceholder } from './TabPlaceholder'
import { SettingsGeneralTab } from './SettingsGeneralTab'
import { SettingsQueriesTab } from './SettingsQueriesTab'
import { SettingsUsersTab } from './SettingsUsersTab'
import { SettingsDatasourcesTab } from './SettingsDatasourcesTab'
import { SettingsNotificationsTab } from './SettingsNotificationsTab'

export function SettingsPage() {
  const { t } = useTranslation('settings')
  const { user } = useAuth()
  const { activeTab, setTab } = useSettingsTab()

  const readOnly = user?.role !== 'admin'

  return (
    <AppShell showAnalytics={false} showTopBar>
      <div className="mx-auto w-full max-w-4xl px-4 py-6">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-foreground">{t('title')}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{t('subtitle')}</p>
        </div>

        {readOnly && (
          <div className="mb-4">
            <ReadOnlyBanner />
          </div>
        )}

        <SettingsTabs activeTab={activeTab} onTabChange={setTab} />

        <div className="mt-6">
          {activeTab === 'general' ? (
            <SettingsGeneralTab readOnly={readOnly} />
          ) : activeTab === 'queries' ? (
            <SettingsQueriesTab readOnly={readOnly} />
          ) : activeTab === 'clients' ? (
            <SettingsUsersTab />
          ) : activeTab === 'datasources' ? (
            <SettingsDatasourcesTab />
          ) : activeTab === 'notifications' ? (
            <SettingsNotificationsTab />
          ) : (
            <TabPlaceholder tab={activeTab} />
          )}
        </div>
      </div>
    </AppShell>
  )
}
